import { render, staticRenderFns } from "./PlanningAssembly.vue?vue&type=template&id=89aa53a0"
import script from "./PlanningAssembly.vue?vue&type=script&lang=js"
export * from "./PlanningAssembly.vue?vue&type=script&lang=js"
import style0 from "./PlanningAssembly.vue?vue&type=style&index=0&id=89aa53a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports